<template>
  <div class="Legend" id="legend">
    <div class="Legend__ctn" v-if="$store.state.activeNavbarItem === 'status'">
      <h4>{{ words[lang].general.LegendLabel }}</h4>
      <LegendItem
        :label="words[lang].general.Abolitionist"
        :color="$COLORS[4]"
        v-on:clicked="toggleAbolitionistLayer"
        :data-active="$store.state.abolitionistLayer"
        :active="$store.state.abolitionistLayer"
        :count="countAbolitionist"
        :countries="$statusPlaces.Abolitionist.countries"
        />
      <LegendItem
        :label="words[lang].general.CommonRightAbolitionist"
        :color="$COLORS[3]"
        v-on:clicked="toggleCommonRightAbolitionistLayer"
        :data-active="$store.state.commonRightAbolitionistLayer"
        :active="$store.state.commonRightAbolitionistLayer"
        :count="countCommonRightAbolitionist"
        :countries="$statusPlaces.CommonRightAbolitionist.countries"
        />
      <LegendItem
        :label="words[lang].general.Moratoire"
        :color="$COLORS[2]"
        v-on:clicked="toggleMoratoireLayer"
        :data-active="$store.state.moratoireLayer"
        :active="$store.state.moratoireLayer"
        :count="countMoratorium"
        :countries="$statusPlaces.Moratorium.countries"
        />
      <LegendItem
        :label="words[lang].general.Retentionist"
        :color="$COLORS[1]"
        v-on:clicked="toggleRetentionistLayer"
        :data-active="$store.state.retentionistLayer"
        :active="$store.state.retentionistLayer"
        :count="countRetentionist"
        :countries="$statusPlaces.Retentionist.countries"
        />
    </div>
    <div class="Legend__ctn" v-if="$store.state.activeNavbarItem === 'treaty' && $store.state.treaty === 'moratorium'">
      <h4>{{ words[lang].general.UniversalMoratoriumVoteLegendTitle }} ({{ $moratoriumDataYear }})</h4>
      <LegendItem
        :label="words[lang].legendLabel.Favorable"
        :color="$COLORS['Oui']"
        v-on:clicked="toggleMoratoriumInFavourLayer"
        :data-active="$store.state.moratoriumInFavourLayer"
        :active="$store.state.moratoriumInFavourLayer"
        :count="countMoratoriumInFavour"
        :countries="$moratoriumPlaces.InFavour.countries"
        />
      <LegendItem
        :label="words[lang].legendLabel.Against"
        :color="$COLORS['Non']"
        v-on:clicked="toggleMoratoriumAgainstLayer"
        :data-active="$store.state.moratoriumAgainstLayer"
        :active="$store.state.moratoriumAgainstLayer"
        :count="countMoratoriumAgainst"
        :countries="$moratoriumPlaces.Against.countries"
        />
      <LegendItem
        :label="words[lang].legendLabel.Abstentions"
        :color="$COLORS['Abstention']"
        v-on:clicked="toggleMoratoriumAbstentionLayer"
        :data-active="$store.state.moratoriumAbstentionLayer"
        :active="$store.state.moratoriumAbstentionLayer"
        :count="countMoratoriumAbstention"
        :countries="$moratoriumPlaces.Abstention.countries"
        />
      <LegendItem
        :label="words[lang].legendLabel.Absences"
        :color="$COLORS['Absent']"
        v-on:clicked="toggleMoratoriumAbsenceLayer"
        :data-active="$store.state.moratoriumAbsenceLayer"
        :active="$store.state.moratoriumAbsenceLayer"
        :count="countMoratoriumAbsence"
        :countries="$moratoriumPlaces.Absence.countries"
        />
    </div>
    <div class="Legend__ctn" v-if="$store.state.activeNavbarItem === 'treaty' && $store.state.treaty === 'op2'">
      <h4>{{ words[lang].general.Op2Ratification }}</h4>
      <LegendItem
        :label="words[lang].legendLabel.Ratified"
        :color="$COLORS['x']"
        v-on:clicked="toggleOp2RatifiedLayer"
        :data-active="$store.state.op2RatifiedLayer"
        :active="$store.state.op2RatifiedLayer"
        :count="countOp2Ratified"
        :countries="$op2Places.Ratified.countries"
        />
      <LegendItem
        :label="words[lang].legendLabel.NotRatified"
        :color="$COLORS['']"
        v-on:clicked="toggleOp2NotRatifiedLayer"
        :data-active="$store.state.op2NotRatifiedLayer"
        :active="$store.state.op2NotRatifiedLayer"
        :count="countOp2NotRatified"
        :countries="$op2Places.NotRatified.countries"
        />
    </div>
    <div class="Legend__right">
      <IconButton
        :hint="$store.state.activeNavbarItem === 'status' ? words[lang].general.ToggleLegendDescription : words[lang].general.ToggleLegendUNDescription"
        icon="info_circle"
        v-on:clicked="toggleSidebar"
        :is-triggerable="true"
        :data-active="$store.state.infoPanelDeployed"
        :active="$store.state.infoPanelDeployed"
        id="toggle"
        :show-hint="showHint"
        />
    </div>
  </div>
</template>

<script>
import { words } from '@/constants/lang'
import LegendItem from './LegendItem.vue'
import IconButton from './IconButton.vue'

export default {
  name: 'Legend',
  components: { LegendItem, IconButton },
  data: () => ({
    words,
    showHint: false
  }),
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    },
    countRetentionist: function () {
      const AMERICA = 1;
      const PORTO_RICO = this.$dataset["PRI"].status === 1 ? 1 : 0;
      return this.$statusPlaces.Retentionist.countries.length + AMERICA - PORTO_RICO;
    },
    countMoratorium: function () {
      const PORTO_RICO = this.$dataset["PRI"].status === 2 ? 1 : 0;
      return this.$statusPlaces.Moratorium.countries.length - PORTO_RICO;
    },
    countCommonRightAbolitionist: function () {
      const PORTO_RICO = this.$dataset["PRI"].status === 3 ? 1 : 0;
      return this.$statusPlaces.CommonRightAbolitionist.countries.length - PORTO_RICO;
    },
    countAbolitionist: function () {
      const PORTO_RICO = this.$dataset["PRI"].status === 4 ? 1 : 0;
      return this.$statusPlaces.Abolitionist.countries.length - PORTO_RICO;
    },

    countMoratoriumInFavour: function () {
      return this.$moratoriumPlaces.InFavour.countries.length;
    },
    countMoratoriumAgainst: function () {
      return this.$moratoriumPlaces.Against.countries.length;
    },
    countMoratoriumAbsence: function () {
      return this.$moratoriumPlaces.Absence.countries.length;
    },
    countMoratoriumAbstention: function () {
      return this.$moratoriumPlaces.Abstention.countries.length;
    },
    countOp2Ratified: function () {
      return this.$op2Places.Ratified.countries.length;
    },
    countOp2NotRatified: function () {
      return this.$op2Places.NotRatified.countries.length;
    },
  },
  methods: {
    toggleSidebar: function () {
      this.$store.commit('toggleInfoPanel')
    },
    toggleAbolitionistLayer: function () {
      let show = !this.$store.state.moratoireLayer && this.$store.state.abolitionistLayer
      this.$store.commit('toggleAbolitionistLayer', true)
      this.$store.commit('toggleMoratoireLayer', show)
      this.$store.commit('toggleCommonRightAbolitionistLayer', show)
      this.$store.commit('toggleRetentionistLayer', show)
    },
    toggleMoratoireLayer: function () {
      let show = !this.$store.state.abolitionistLayer && this.$store.state.moratoireLayer
      this.$store.commit('toggleAbolitionistLayer', show)
      this.$store.commit('toggleMoratoireLayer', true)
      this.$store.commit('toggleCommonRightAbolitionistLayer', show)
      this.$store.commit('toggleRetentionistLayer', show)
    },
    toggleCommonRightAbolitionistLayer: function () {
      let show = !this.$store.state.abolitionistLayer && this.$store.state.commonRightAbolitionistLayer
      this.$store.commit('toggleAbolitionistLayer', show)
      this.$store.commit('toggleMoratoireLayer', show)
      this.$store.commit('toggleCommonRightAbolitionistLayer', true)
      this.$store.commit('toggleRetentionistLayer', show)
    },
    toggleRetentionistLayer: function () {
      let show = !this.$store.state.abolitionistLayer && this.$store.state.retentionistLayer
      this.$store.commit('toggleAbolitionistLayer', show)
      this.$store.commit('toggleMoratoireLayer', show)
      this.$store.commit('toggleCommonRightAbolitionistLayer', show)
      this.$store.commit('toggleRetentionistLayer', true)
    },

    toggleMoratoriumInFavourLayer: function () {
      let show = !this.$store.state.moratoriumAgainstLayer && this.$store.state.moratoriumInFavourLayer
      this.$store.commit('toggleMoratoriumInFavourLayer', true)
      this.$store.commit('toggleMoratoriumAgainstLayer', show)
      this.$store.commit('toggleMoratoriumAbstentionLayer', show)
      this.$store.commit('toggleMoratoriumAbsenceLayer', show)
    },
    toggleMoratoriumAgainstLayer: function () {
      let show = !this.$store.state.moratoriumInFavourLayer && this.$store.state.moratoriumAgainstLayer
      this.$store.commit('toggleMoratoriumInFavourLayer', show)
      this.$store.commit('toggleMoratoriumAgainstLayer', true)
      this.$store.commit('toggleMoratoriumAbstentionLayer', show)
      this.$store.commit('toggleMoratoriumAbsenceLayer', show)
    },
    toggleMoratoriumAbstentionLayer: function () {
      let show = !this.$store.state.moratoriumAgainstLayer && this.$store.state.moratoriumAbstentionLayer
      this.$store.commit('toggleMoratoriumInFavourLayer', show)
      this.$store.commit('toggleMoratoriumAgainstLayer', show)
      this.$store.commit('toggleMoratoriumAbstentionLayer', true)
      this.$store.commit('toggleMoratoriumAbsenceLayer', show)
    },
    toggleMoratoriumAbsenceLayer: function () {
      let show = !this.$store.state.moratoriumAgainstLayer && this.$store.state.moratoriumAbsenceLayer
      this.$store.commit('toggleMoratoriumInFavourLayer', show)
      this.$store.commit('toggleMoratoriumAgainstLayer', show)
      this.$store.commit('toggleMoratoriumAbstentionLayer', show)
      this.$store.commit('toggleMoratoriumAbsenceLayer', true)
    },


    toggleOp2RatifiedLayer: function () {
      let show = !this.$store.state.op2NotRatifiedLayer && this.$store.state.op2RatifiedLayer
      this.$store.commit('toggleOp2RatifiedLayer', true)
      this.$store.commit('toggleOp2NotRatifiedLayer', show)
    },
    toggleOp2NotRatifiedLayer: function () {
      let show = !this.$store.state.op2RatifiedLayer && this.$store.state.op2NotRatifiedLayer
      this.$store.commit('toggleOp2RatifiedLayer', show)
      this.$store.commit('toggleOp2NotRatifiedLayer', true)
    }
  }
}
</script>

<style scoped lang="less">

  @import "../less/_var.less";
  .Legend {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    bottom: 0;
    left: 0;
    position: absolute;
    z-index: 2;
    padding: 10px 22px;
    margin: 0;
    box-sizing: border-box;
    border-top: solid 1px #ccc;
    border-width: 1px 0 0 1px;
    width: 100%;

    .Legend__ctn {
      font-family: @font-primary;
      display: flex;
      height: 60px;
      flex-flow: column wrap;
      justify-content: center;
      font-weight: 100;

      .LegendItem {
        margin: 5px 40px 5px 0;
      }

      h4 {
        text-transform: uppercase;
        margin: auto 20px auto 0;
        color: #222;
        font-family: @font-secondary;
        font-size: 0.8em;
        font-weight: 400;
        height: 100%;
        max-width: 180px;
        line-height: 1.4em;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
      }

      @media screen and (max-width: 640px) {
        & {
          height: initial;
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    .Legend {
      align-items: flex-start;
      font-size: 90%;
      padding: 8px;

      .Legend__ctn {
        h4 {
          max-width: none;
          margin-bottom: 4px;
          align-items: flex-start;
        }

        .LegendItem {
          margin: 3px 0;
          font-size: 0.75em;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>
